import { ComputedStyle } from 'shared/vidio_helpers';
import $ from 'jquery';

export default class GtmMobileWatchPage {
  static init() {
    this.bindRelatedVideoImpression();
    this.bindRelatedVideoClick();
    this.bindMoreUserVideoImpression();
    this.bindMoreUserVideoClick();
    this.bindCommentImpression();
    this.bindCommentPopupClick();
    this.bindCommentSubmitClick();
    this.bindAppCampaignClick();
  }

  static sendDataLayer(properties){
    window.dataLayer.push(properties);
  }

  static inViewPort(element) {
    if (  !element || (element.nodeType !== 1) ||
          ComputedStyle.get(element.closest('.tab-pane'), 'display') === 'none') {
      return false;
    }
    var rect = element.getBoundingClientRect();
    var height = document.documentElement.clientHeight;

    return (!!rect && rect.bottom >= 0 && rect.top <= height);
  }

  static bindRelatedVideoImpression() {
    var impressionEventSent = false;
    var el = $('#section-related-videos')[0];

    $(window).scroll(() => {
      if (!impressionEventSent && this.inViewPort(el)) {
        var properties = {
          event             : 'impression',
          feature_name      : 'watchpage',
          feature_location  : 'video terkait'
        };
        GtmMobileWatchPage.sendDataLayer(properties);
        impressionEventSent = true;
      }
    });
  }

  static bindRelatedVideoClick() {
    $('#section-related-videos').on('click', '.b-video-card a[data-reco-title]', function() {
      var properties = {
        event             : 'click',
        feature_name      : 'watchpage',
        feature_location  : 'video terkait.' + this.getAttribute('data-position'),
        feature_type      : 'vod.' + this.getAttribute('data-id')
      };
      GtmMobileWatchPage.sendDataLayer(properties);
    });
  }

  static bindMoreUserVideoImpression() {
    var impressionEventSent = false;
    var el = $('#section-more-user-videos')[0];

    $(window).scroll(() => {
      if (!impressionEventSent && this.inViewPort(el)) {
        var properties = {
          event             : 'impression',
          feature_name      : 'watchpage',
          feature_location  : 'video lainnya'
        };
        GtmMobileWatchPage.sendDataLayer(properties);
        impressionEventSent = true;
      }
    });
  }

  static bindMoreUserVideoClick() {
    $('#section-more-user-videos').on('click', '.b-video-card a[data-id][data-position]', function() {
      var properties = {
        event             : 'click',
        feature_name      : 'watchpage',
        feature_location  : 'video lainnya.' + this.getAttribute('data-position'),
        feature_type      : 'vod.' + this.getAttribute('data-id')
      };
      GtmMobileWatchPage.sendDataLayer(properties);
    });
  }

  static bindCommentImpression() {
    var impressionEventSent = false;
    var el = $('#section-comments')[0];

    $(window).scroll(() => {
      if (!impressionEventSent && this.inViewPort(el)) {
        var properties = {
          event             : 'impression',
          feature_name      : 'watchpage',
          feature_location  : 'komentar'
        };
        GtmMobileWatchPage.sendDataLayer(properties);
        impressionEventSent = true;
      }
    });
  }

  static bindCommentPopupClick() {
    $('#section-comments').on('click', '.b-comment__input-field, .comments__actions-reply', function() {
      var properties = {
        event             : 'click',
        feature_name      : 'watchpage',
        feature_location  : 'komentar.box'
      };
      GtmMobileWatchPage.sendDataLayer(properties);
    });
  }

  static bindCommentSubmitClick() {
    $('body').on('click', '.b-comment-popup .b-comment-popup__button--send', function() {
      var properties = {
        event             : 'click',
        feature_name      : 'watchpage',
        feature_location  : 'komentar.submit'
      };
      GtmMobileWatchPage.sendDataLayer(properties);
    });
  }

  static bindShareButtonClick(type) {
    $(".share.share--"+type).click(function() {
      var properties = {
        event             : 'click',
        feature_name      : 'share',
        feature_location  : 'watchpage/'+type,
        feature_type      : 'vod.'+this.getAttribute('data-video-id')
      };
      GtmMobileWatchPage.sendDataLayer(properties);
    });
  }

  static bindAppCampaignClick() {
    $('.js-component[data-component="MobileAppCampaign"]').click(function() {
      var properties = {
        event             : 'click',
        feature_name      : 'ads',
        feature_location  : 'smart banner'
      };
      GtmMobileWatchPage.sendDataLayer(properties);
    });
  }
}

